 <app-navigation></app-navigation>
    <!-- <div [@routeTransitionAnimations]> -->
    <div id="main-content" [attr.role]="globals.pageHasOwnMain ? null : 'main'">
      <router-outlet></router-outlet>
    </div>
    <!-- </div> --> 
<app-navigation-footer></app-navigation-footer>
<app-get-the-app-toast></app-get-the-app-toast>